import { Component, OnInit } from '@angular/core';
import { BuildingService } from 'src/app/shared/services/building/building.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BuildingModel } from '../../models/building.model';

@Component({
  selector: 'app-building-badge',
  templateUrl: './building-badge.component.html',
  styleUrls: ['./building-badge.component.scss']
})
export class BuildingBadgeComponent implements OnInit {
  building$: Observable<any> = this.bldgSrv.getBuildingBadge(this.activatedRoute.snapshot.params.buildingId);

  constructor(
    private bldgSrv: BuildingService,
    private router: Router,
    private activatedRoute: ActivatedRoute
    ) { }

  ngOnInit() {
  }

  onBuildingClick() {
    this.router.navigate(['building-dashboard/info']);  }

}
